import AutoComplete from 'material-ui/AutoComplete';

const autocompleteFilter = (searchText, value) =>
  AutoComplete.fuzzyFilter(searchText, value) ||
  AutoComplete.levenshteinDistance(searchText, value) < 3;

export default autocompleteFilter;
